import { classAdderBuilder } from '@smui/common/classadder';
export default classAdderBuilder({
    class: 'mdc-dialog__header',
    tag: 'div',
    contexts: {
        'SMUI:icon-button:context': 'dialog:header',
    },
});
//# sourceMappingURL=Header.js.map